export enum AnonymizationLevel {
    None = 0,
    Anonymize = 1,
    LowBlur = 2,
    HighBlur = 3,
    AnonymizeLowBlur = 4,
    AnonymizeHighBlur = 5,
    Military = 6,
    LowPixelization = 7,
    MediumPixelization = 8,
    HighPixelization = 9,
    AdvancedAdaptivePixelization = 10,
    HumanOnlyAnonymization = 11,
    HumanOnlyMediumPixelizationGray = 12,
    HumanOnlyHighPixelizationGray = 13,
}
